module.exports = __webpack_public_path__ + "img/right-landingpage.bb3ad907.png";